export default __webpack_public_path__ + "static/media/Rubik-Light.d950a011.ttf";